import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ReplaySubject } from 'rxjs';
import { Company, CompanySalesConfig } from '../interfaces/company.interface';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  // subjects
  Company: ReplaySubject<Company> = new ReplaySubject(1);
  Companies: ReplaySubject<Company[]> = new ReplaySubject(1);

  // params
  companiesProcessing = false;
  lastId?: number;

  companySalesConfig: object = {};

  private _salesSystemConfigKey: string = 'salesSystemConfig';

  // endpoints
  private _companyEp: string = `${this._apiSvc.endpoints.monolith}/api/Company`;

  private _companyInvLookupFilterEp: string = `${this._apiSvc.endpoints.monolith}/api/Company/invlookupfilter`;

  constructor(
    private _apiSvc: ApiService,
    private _lsSvc: LocalStorageService
  ) { }

  get httpHeaders(): any {
    return this._apiSvc.getHttpHeaders();
  }

  /**
   * Get single company
   * @param id
   */
  getCompany(id: number): void {

    this._apiSvc.get(`${this._companyEp}/${id}`)
      .subscribe((res: any) => {
        this.Company.next(res);
      });

  }

  /**
   * Get company by id
   * @param id
   * @returns observable
   */
  get(id: number): any {
    return this._apiSvc.get(`${this._companyEp}/${id}`);
  }

  /**
   * Get companies
   */
  getCompanies(): void {

    if (this.companiesProcessing) return;

    this.companiesProcessing = true;

    const params = {
      sort: `CompanyCode-asc`
    };

    this._apiSvc.search(`${this._companyEp}`, params)
      .subscribe((res: any) => {
        this.companiesProcessing = false;
        this.Companies.next(res);
      }, () => {
        this.companiesProcessing = false;
      });

  }

  /**
   * Update company
   * @param companyId 
   * @param values 
   * @returns 
   */
  update(companyId: number, values: Company): any {
    return this._apiSvc.update(`${this._companyEp}/${companyId}`, values);
  }

    /**
   * Update invLookupFilter
   * @param companyId 
   * @param values 
   * @returns 
   */
    updateInvLookupFilter(companyId: number, values: Company): any {
      return this._apiSvc.update(`${this._companyInvLookupFilterEp}/${companyId}`, values);
    }
  

  /**
   * Update company system config
   */
  updateCompanySystemConfig(data?: CompanySalesConfig): void {

    // if data exists update the value in localstorage else get the data from the api
    if (data) {
      this._lsSvc.setItem(this._salesSystemConfigKey, data);
      return;
    }

    // get the user to get the user's company id
    const user = this._lsSvc.getItem('user');

    // get sales config
    this._apiSvc.get(`${this._apiSvc.endpoints.sales}/api/ParametersPcsls/${user.companyId}`)
      .subscribe((res: any) => {

      // set config in local storage
        this._lsSvc.setItem(this._salesSystemConfigKey, res);
      
      });

  }

  /**
   * Check to see if company has delivery calendar sales config enabled
   * @returns 
   */
  hasUseDeliveryCalendarSales(): boolean {
    const salesSystemConfig: CompanySalesConfig = this._lsSvc.getItem(this._salesSystemConfigKey);
    return salesSystemConfig?.UseDeliveryCalendarSales;
  }

  /**
   * Check if delivery calendar system setting is enabled
   * @param program 
   * @returns 
   */
  hasSalesDeliveryCalenderSetting(program: string): any {

    const salesPrograms: any = {
      returns: 'UseDeliveryCalendarReturns',
      sales: 'UseDeliveryCalendarSales',
      services: 'UseDeliveryCalendarServices'
    };

    const salesProgram: any = salesPrograms[program];
    if (salesProgram) {
      const salesSystemConfig: any = this._lsSvc.getItem(this._salesSystemConfigKey);
      return salesSystemConfig ? salesSystemConfig[salesProgram] : null;
    } else {
      console.error('Invalid program name');
    }

  }

}
